import { Box } from '@mui/material';
import { useMeasurementWizardStore } from '@/store/useMeasurementWizardStore';
import { PatientSelectionPanel } from './patient/PatientSelectionPanel';
import { PatientDetailsPanel } from './patient/PatientDetailsPanel';
import { AddNewPatientForm } from './patient/AddNewPatientForm';
import { AnonymousPatientPanel } from './patient/AnonymousPatientPanel';

/**
 * PatientPanel - Patient selection and management
 * 
 * Task 05 implementation - Full patient management with:
 * 1. Patient Selection (search + list)
 * 2. Patient Details (name, DOB, sex, history)
 * 3. Add New Patient (form with anonymous option + survey)
 * 4. Edit Patient (reuses Add New form)
 */
export function PatientPanel() {
  const patientPanelMode = useMeasurementWizardStore((s) => s.patientPanelMode);
  const selectedPatientId = useMeasurementWizardStore((s) => s.selectedPatientId);

  return (
    <Box>
      {patientPanelMode === 'selection' && <PatientSelectionPanel />}
      {patientPanelMode === 'details' && <PatientDetailsPanel />}
      {patientPanelMode === 'anonymous' && <AnonymousPatientPanel />}
      {patientPanelMode === 'add-new' && <AddNewPatientForm />}
      {patientPanelMode === 'edit' && (
        <AddNewPatientForm editMode patientId={selectedPatientId || undefined} />
      )}
    </Box>
  );
}
